import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** For one of a set (a pace, a filter): whether it is the one chosen. */
  readonly on?: boolean;
  /** For a word that folds a panel: whether the panel is open. */
  readonly expanded?: boolean;
}

/**
 * The small words round the edge of a page that change how it is shown, not what happens in the game: a pace,
 * the theme, the text size, a panel folded away, a filter. They are all drawn the one way: muted until pointed
 * at, and the chosen one in ink over the ember line that navigation uses.
 */
export function ToggleWord({ on, expanded, className, ...rest }: Props) {
  return (
    <button
      type="button"
      className={className ? `toggle-word ${className}` : "toggle-word"}
      aria-pressed={on}
      aria-expanded={expanded}
      {...rest}
    />
  );
}
